import React, { useContext } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { IoMenu } from 'react-icons/io5'
import { useTranslation } from 'react-i18next'
import DashSideNav from '../components/DashSideNav/DashSideNav'
import { NavContext } from '../Context/NavContext'
import { UserContext } from '../Context/UserContext'
import './AdminLayout.scss'
import './Admin/Navs.scss'

function roleLabelKey(role) {
    if (role === 'Owner') return 'roleLabelOwner'
    if (role === 'Admin') return 'roleLabelAdmin'
    return 'roleLabelStaff'
}

export default function AdminLayout() {
    const { pathname } = useLocation()
    const { DashSideNav: dashNavOpen, ShowDashNav } = useContext(NavContext)
    const { UserInformation } = useContext(UserContext)
    const { t } = useTranslation()
    const isLogin = pathname === '/Login2030'

    const sessionUser =
        UserInformation && typeof UserInformation === 'object' ? UserInformation : null

    let displayName = t('adminWelcomeGuest')
    if (sessionUser) {
        const n = sessionUser.name && String(sessionUser.name).trim()
        if (n) displayName = n
        else if (sessionUser.email) {
            displayName = String(sessionUser.email).split('@')[0] || displayName
        }
    }

    const role = sessionUser?.role
    const roleText = role ? t(roleLabelKey(role)) : null
    const roleModifier =
        role === 'Owner' ? 'owner' : role === 'Admin' ? 'admin' : 'staff'

    if (isLogin) {
        return <>
            <DashSideNav />
            <Outlet />
        </>
    }

    return <>
        <DashSideNav />
        <div className="Control">
            <nav className="admin-dash-mobile-nav" aria-label="Admin menu">
                <button
                    type="button"
                    className="admin-dash-menu-trigger"
                    aria-expanded={dashNavOpen}
                    aria-controls="admin-dash-sidenav"
                    onClick={() => ShowDashNav()}
                >
                    <IoMenu aria-hidden />
                </button>
            </nav>

            <header className="admin-dash-welcome" aria-labelledby="admin-dash-welcome-heading">
                <div className="admin-dash-welcome__main">
                    <p className="admin-dash-welcome__eyebrow">{t('adminWelcomeEyebrow')}</p>
                    <h2 id="admin-dash-welcome-heading" className="admin-dash-welcome__title">
                        {t('adminWelcomeBack')},{' '}
                        <span className="admin-dash-welcome__name">{displayName}</span>
                    </h2>
                    <p className="admin-dash-welcome__subtitle">{t('adminWorkspaceSubtitle')}</p>
                </div>
                <div className="admin-dash-welcome__aside">
                    {role ? (
                        <span className={`admin-dash-welcome__role admin-dash-welcome__role--${roleModifier}`}>
                            {roleText}
                        </span>
                    ) : null}
                    {sessionUser?.email ? (
                        <span className="admin-dash-welcome__email">{sessionUser.email}</span>
                    ) : null}
                </div>
            </header>

            <Outlet />
        </div>
    </>
}
